import { RouteProps } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import { IndiaLandingPage } from 'pages/IndiaLandingPage';
import { RussiaLandingPage } from 'pages/RussiaLandingPage';
import { RussiaOnboardingSuccessPage } from 'pages/RussiaOnboardingSuccessPage';
import { RussiaExistingAccountPage } from 'pages/RussiaExistingAccountPage';
import { SetupPage } from 'pages/SetupPage';
import MainPage from 'pages/MainPage';
import NotFoundPage from 'pages/NotFoundPage';
import { SignUpPage } from 'pages/SignUpPage';
import SuccessfulPaymentPage from 'pages/SuccessfulPaymentPage';
import OtpCheckPage from 'pages/OtpCheckPage';
import TestPage from 'pages/TestPage';
import StripeCallbackPage from 'pages/StripeCallbackPage';

import {
  AppRoutes,
  getRouteIndiaLanding,
  getRouteLogin,
  getRouteMain,
  getRouteOtpCheck,
  getRouteRussiaLanding,
  getRouteRussiaOnboardingSuccess,
  getRouteRussiaExistingAccount,
  getRouteSetup,
  getRouteSuccessfulPayment,
  getSignUp,
  getRouteTest,
  getRouteStripeCallback,
} from 'shared/consts/routes';

export type AppRoutesProps = RouteProps & {
  authOnly?: boolean;
  title: string;
};

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
  [AppRoutes.TEST]: {
    path: getRouteTest(),
    element: <TestPage />,
    authOnly: false,
    title: 'Private Gate - Test',
  },
  [AppRoutes.MAIN]: {
    path: getRouteMain(),
    element: <MainPage />,
    authOnly: true,
    title: 'Private Gate - Личный кабинет',
  },
  [AppRoutes.LOGIN]: {
    path: getRouteLogin(),
    element: <LoginPage />,
    authOnly: false,
    title: 'Private Gate - Вход',
  },
  [AppRoutes.INDIA_LANDING]: {
    path: getRouteIndiaLanding(),
    element: <IndiaLandingPage />,
    authOnly: false,
    title: 'Private Gate - Регистрация (Индия)',
  },
  [AppRoutes.RUSSIA_LANDING]: {
    path: getRouteRussiaLanding(),
    element: <RussiaLandingPage />,
    authOnly: false,
    title: 'Private Gate - Регистрация (Россия)',
  },
  [AppRoutes.RUSSIA_ONBOARDING_SUCCESS]: {
    path: getRouteRussiaOnboardingSuccess(),
    element: <RussiaOnboardingSuccessPage />,
    authOnly: true,
    title: 'Private Gate - VPN готов',
  },
  [AppRoutes.RUSSIA_EXISTING_ACCOUNT]: {
    path: getRouteRussiaExistingAccount(),
    element: <RussiaExistingAccountPage />,
    authOnly: false,
    title: 'Private Gate - Аккаунт уже зарегистрирован',
  },
  [AppRoutes.SETUP]: {
    path: getRouteSetup(),
    element: <SetupPage />,
    authOnly: false,
    title: 'Private Gate - Настройка VPN',
  },
  [AppRoutes.SIGN_UP]: {
    path: getSignUp(),
    element: <SignUpPage />,
    authOnly: false,
    title: 'Private Gate - Регистрация',
  },
  [AppRoutes.OTP_CHECK]: {
    path: getRouteOtpCheck(),
    element: <OtpCheckPage />,
    authOnly: false,
    title: 'Private Gate - Подтверждение кода',
  },
  [AppRoutes.SUCCESSFUL_PAYMENT]: {
    path: getRouteSuccessfulPayment(),
    element: <SuccessfulPaymentPage />,
    authOnly: true,
    title: 'Private Gate - Успешная оплата',
  },
  [AppRoutes.STRIPE_CALLBACK]: {
    path: getRouteStripeCallback(),
    element: <StripeCallbackPage />,
    authOnly: false,
    title: 'Private Gate - Статус оплаты',
  },
  [AppRoutes.NOT_FOUND]: {
    path: '*',
    element: <NotFoundPage />,
    authOnly: false,
    title: 'Private Gate - Страница не найдена',
  },
};
